module.exports = __webpack_public_path__ + "img/22logo-black@2x.5c6b5fea.png";